import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ContainerButton,
  Description,
  Title,
  Button,
  ButtonCancel,
} from './styles';

const HELP_CENTER_LINK = 'http://help.playbookux.com/en/articles/6725886-chrome-extension-permissions';

const MicrophoneCheck = (props) => {
  const {
    setCurrentStep,
    STEPS,
    history,
  } = props;

  const [hasError, setHasError] = useState(false);

  const handleCancel = () => {
    history.goBack();
  };

  const handleNextStep = () => {
    if (hasError) return;
    setCurrentStep(STEPS.SCREEN_SHARE_INSTRUCTIONS);
  };

  const handleMicCheck = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true, video: false });

      await navigator.mediaDevices.enumerateDevices();
    } catch (e) {
      if (e.name === 'NotAllowedError') {
        setHasError(true);
      }
    }
  };

  useEffect(() => {
    handleMicCheck();
  }, []);

  return (
    <Container>
      <Title>Microphone check</Title>

      <Description>
        {hasError ? (
          <>
            Permissions was denied. Please allow microphone access and try again.
            <a href={HELP_CENTER_LINK} target="_blank" rel="noopener noreferrer">{' Learn more here.'}</a>
          </>
        ) : 'Everything is working! You can continue. '}
      </Description>

      <ContainerButton>
        <ButtonCancel onClick={handleCancel}>
          Cancel
        </ButtonCancel>
        <Button onClick={handleNextStep} disabled={hasError}>
          Continue
        </Button>
      </ContainerButton>
    </Container>
  );
};

MicrophoneCheck.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  STEPS: PropTypes.shape({
    SCREEN_SHARE_INSTRUCTIONS: PropTypes.string,
  }).isRequired,
};

export default MicrophoneCheck;
